

import { clearTokens,validateToken } from "./TokenHandler";

export function fetchCall(url, fetchConfig) {

    return new Promise((resolve,reject)=>{
        validateToken().then(()=>{
            fetchConfig = fetchConfig||{};
            const headers = {...fetchConfig.headers,
                Authorization:"Bearer " + localStorage.getItem("TOKEN")
            };
            const updatedConfig = {...fetchConfig,headers:headers};
            //console.log(updatedConfig);
            const serviceResult = serviceCall(url, updatedConfig);
            resolve(serviceResult);
        }).catch(err=>{
            //console.error(err.message);
            HandleStatusCode({status:401});
            reject(err)
        });
    })


    function serviceCall(url, fetchConfig){
        return fetch(url, fetchConfig)
        .then((res) => HandleStatusCodeThenJson(res))
        .catch((err) => {
            console.log("Error, with message:", err.statusText);
            clearTokens();
            throw (err);
        });
    }

}

export function HandleStatusCodeThenJson(response) {

    HandleStaleVersion(response);
    HandleStatusCode(response);

    return response.json();
}
export function HandleStaleVersion(response) {
    
    const buildVersionFromServer = response.headers.get('X-Response-Build-Version');
    const buildVersionSavedInClient = localStorage.getItem("VERSION");
    if(buildVersionFromServer !== buildVersionSavedInClient){
        console.log('You have a new version of application available.');
        console.log('Clearing browser cache...');
        caches.keys().then((keyList) => {
            return Promise.all(
              keyList.map((key) => {
                return caches.delete(key);
              })
            );
          });
        localStorage.setItem("VERSION",buildVersionFromServer);
        console.log('Updating application to latest version...');
        setTimeout(() => {
            window.location.reload();
          }, 1000);
        console.log('Updated application to latest version.');
    }    

    return response;
}

export function HandleStatusCode(response) {
    
    if(response.status === 401 || response.status === 404 || response.status === 500) {
        clearTokens();
        const ssoLogoutUrl = localStorage.getItem("SSO_LOGOUT_URL");
        const redirectUrl = (ssoLogoutUrl) ? ssoLogoutUrl : '/login';
        window.location.replace(redirectUrl);
    }

    return response;
}

export function LogInfo(info) {
    //console.log('LogInfo() '+info);
    fetch('/log/info', {
            method: "POST",
            cache: "no-cache",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(info),
        })
        .then(response => {
            //done
        })
        .catch(error => {
            console.error(error);
        })

}

export function LogError(errInfo) {
    console.error(errInfo);
    fetch('/log/error', {
            method: "POST",
            cache: "no-cache",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(errInfo),
        })
        .then(response => {
            //done
        })
        .catch(error => {
            console.error(error);
        })

}